const NEAR_SQUARE = 0.1;
export function orientationOf(width, height) {
    if (!width || !height || width <= 0 || height <= 0)
        return null;
    const long = Math.max(width, height);
    const short = Math.min(width, height);
    if (long / short <= 1 + NEAR_SQUARE)
        return "both";
    return width > height ? "landscape" : "portrait";
}
export function aspectLabel(width, height) {
    if (!width || !height || width <= 0 || height <= 0)
        return null;
    const ratio = width / height;
    if (Math.abs(ratio - 16 / 9) / (16 / 9) <= 0.02)
        return "16:9";
    if (Math.abs(ratio - 9 / 16) / (9 / 16) <= 0.02)
        return "9:16";
    const g = gcd(width, height);
    return `${Math.round(width / g)}:${Math.round(height / g)}`;
}
function gcd(a, b) {
    return b === 0 ? a : gcd(b, a % b);
}
export const ORIENTATION_LABELS = {
    landscape: "Landscape",
    portrait: "Portrait",
    both: "Fits both",
};
export function fitsScreen(content, screen) {
    return content === "both" || content === screen;
}
export function combinedOrientation(items) {
    let landscape = false;
    let portrait = false;
    for (const o of items) {
        if (o === "landscape")
            landscape = true;
        else if (o === "portrait")
            portrait = true;
    }
    if (landscape && portrait)
        return "mixed";
    if (landscape)
        return "landscape";
    if (portrait)
        return "portrait";
    return "both";
}
export function joinsList(item, list) {
    if (!item || item === "both" || list === "both")
        return true;
    return item === list;
}
export function orientationOfResolution(resolution) {
    if (!resolution)
        return null;
    const m = /(\d+)\s*[x×]\s*(\d+)/i.exec(resolution);
    if (!m)
        return null;
    const w = Number(m[1]);
    const h = Number(m[2]);
    if (!w || !h)
        return null;
    return h > w ? "portrait" : "landscape";
}
export function unitOrientation(stored, reportedResolution) {
    var _a;
    return (_a = stored !== null && stored !== void 0 ? stored : orientationOfResolution(reportedResolution)) !== null && _a !== void 0 ? _a : "landscape";
}
export function rotationMismatch(stored, reportedResolution) {
    const reported = orientationOfResolution(reportedResolution);
    return stored && reported && reported !== stored ? reported : null;
}
const KIND_FILTERS = ["image", "video"];
export function matchesMediaFilters(file, filters) {
    if (filters.length === 0)
        return true;
    const kinds = filters.filter((f) => KIND_FILTERS.includes(f));
    const shapes = filters.filter((f) => !KIND_FILTERS.includes(f));
    if (kinds.length > 0) {
        const isVideo = file.contentType.startsWith("video/");
        const wanted = isVideo ? "video" : "image";
        if (!kinds.includes(wanted))
            return false;
    }
    if (shapes.length > 0) {
        if (!file.orientation)
            return false;
        if (!shapes.includes(file.orientation))
            return false;
    }
    return true;
}
export function dimensionLabel(width, height) {
    if (!width || !height)
        return null;
    return `${width}×${height}`;
}
export function purgeStateOf(purgeAt, now = Date.now()) {
    if (!purgeAt)
        return "none";
    const t = purgeAt instanceof Date ? purgeAt.getTime() : Date.parse(purgeAt);
    if (!Number.isFinite(t))
        return "none";
    return t <= now ? "overdue" : "scheduled";
}
export function purgeDateLabel(purgeAt) {
    if (!purgeAt)
        return null;
    const d = purgeAt instanceof Date ? purgeAt : new Date(purgeAt);
    if (Number.isNaN(d.getTime()))
        return null;
    return d.toISOString().slice(0, 10);
}
export function durationLabel(seconds) {
    if (seconds === null || seconds === undefined || seconds <= 0)
        return null;
    const total = Math.round(seconds);
    const h = Math.floor(total / 3600);
    const m = Math.floor((total % 3600) / 60);
    const s = total % 60;
    const pad = (n) => n.toString().padStart(2, "0");
    return h > 0 ? `${h}:${pad(m)}:${pad(s)}` : `${pad(m)}:${pad(s)}`;
}
